import { render, staticRenderFns } from "./Movement.vue?vue&type=template&id=7b5aa022&scoped=true&"
import script from "./Movement.vue?vue&type=script&lang=js&"
export * from "./Movement.vue?vue&type=script&lang=js&"
import style0 from "./Movement.vue?vue&type=style&index=0&id=7b5aa022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5aa022",
  null
  
)

export default component.exports